module.exports = __webpack_public_path__ + "img/Jumpicon2.224e4752.svg";